import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import VerifyEmailModal from './verify-email-modal';
import { useModal } from '../../../../../../hooks/use-modal';
import { emailVerificationStatusMap } from './constants';
import messages from '../../messages';
import style from '../style.module.less';

const EmailVerificationStatus = ({
  email,
  verificationStatus = emailVerificationStatusMap.Unverified.value,
  isLoading = false,
  getEmailVerificationStatus,
}) => {
  const { close, isOpen, open } = useModal();
  if (isLoading) {
    return (
      <div className={style['verify-email']}>
        <LoadingIndicator className={style['verify-email-icon']} />
        <FormattedMessage {...messages.checkingStatus} />
      </div>
    );
  }
  const matchingStatus = emailVerificationStatusMap[verificationStatus];
  const { icon, message } = matchingStatus;
  return (
    <div className={style['verify-email']}>
      {icon}
      <FormattedMessage
        {...message}
        values={{
          buttonLink: (chunks) => (
            <Button className={style['verify-email-link']} onClick={open} theme='link'>
              {chunks}
            </Button>
          ),
        }}
      />
      {isOpen && <VerifyEmailModal email={email} getEmailVerificationStatus={getEmailVerificationStatus} onClose={close} />}
    </div>
  );
};

EmailVerificationStatus.propTypes = {
  email: PropTypes.string.isRequired,
  verificationStatus: PropTypes.string,
  isLoading: PropTypes.bool,
  getEmailVerificationStatus: PropTypes.func.isRequired,
};

export default EmailVerificationStatus;
